/**
 * Utility function to update document title with hotel name
 * @param hotelName - The name of the hotel
 * @param pageName - Optional page name to append
 */
export const updatePageTitle = (hotelName?: string, pageName?: string): void => {
  if (hotelName) {
    const title = pageName ? `QRoom | ${hotelName} - ${pageName}` : `QRoom | ${hotelName}`;
    document.title = title;
  } else {
    document.title = pageName ? `QRoom - ${pageName}` : 'QRoom';
  }
};

/**
 * Reset page title to default
 */
export const resetPageTitle = (): void => {
  document.title = 'QRoom';
}; 